import { lang } from '../../assets/lang'

export const newPostbackHtml = () => {
  const isSequenceAddonAvailable = !! window.xitFlowBuilderData.sequence_addon

  return isSequenceAddonAvailable ?
    '<div class="form-group text-left mt-4">' +
      '<label for="new-postback-postback-title">' + lang.postback_new_html_label_title + '</label>' +
      '<input type="text" id="new-postback-postback-title" class="form-control">' +
    '</div>' +
    
    '<div class="form-group text-left mt-4">' +
      '<div class="d-flex justify-content-between">' +
        '<label for="reference-choose-label">' + lang.postback_html_label_label + '</label>' +
        '<span class="text-small text-primary text-underline" data-toggle="tooltip" data-original-title="' + lang.postback_html_label_create_new_info + '"><i class="fas fa-plus-circle"></i> ' + lang.postback_html_label_create_new + '</span>' +
      '</div>' + 
      '<select id="new-postback-choose-label" class="form-control select2 new-postback-hidable-field" multiple="">' +
      '</select>' +
    '</div>' +
    
    '<div class="form-group text-left mt-3">' +
      '<label for="new-postback-choose-sequence">' + lang.postback_new_html_sequence + '</label>' +
      '<select id="new-postback-choose-sequence" class="form-control select2 new-postback-hidable-field">' +
      '</select>' +
    '</div>'
    
    :

    '<div class="form-group text-left mt-4">' +
      '<label for="new-postback-postback-title">' + lang.postback_new_html_label_title + '</label>' +
      '<input type="text" id="new-postback-postback-title" class="form-control">' +
    '</div>' +
    
    '<div class="form-group text-left mt-2">' +
      '<label for="new-postback-choose-label">' + lang.postback_new_html_label + '</label>' +
      '<select id="new-postback-choose-label" class="form-control select2 new-postback-hidable-field" multiple="">' +
      '</select>' +
    '</div>'
}